const APP_ORIGIN = "https://www.venturu.com";
const APP_HOSTS = new Set(["venturu.com", "www.venturu.com"]);

export type MessageWebLink = {
  href: string;
  hostname: string;
  external: boolean;
  insecure: boolean;
};

/** Validate message links without fetching them or treating a valid URL as trusted. */
export function parseMessageWebLink(value: string): MessageWebLink | null {
  const href = value.trim();
  if (!href || /[\p{Cc}\p{Bidi_Control}\\]/u.test(value)) {
    return null;
  }
  const relative =
    (href.startsWith("/") && !href.startsWith("//")) || href.startsWith("#");
  if (!relative && !/^https?:\/\//i.test(href)) return null;

  try {
    const url = new URL(href, APP_ORIGIN);
    if (
      !["http:", "https:"].includes(url.protocol) ||
      !url.hostname ||
      url.username ||
      url.password ||
      (!url.hostname.startsWith("[") && !/^[a-z\d.-]+$/i.test(url.hostname)) ||
      url.hostname
        .split(".")
        .some((label) => !label || label.startsWith("-") || label.endsWith("-"))
    )
      return null;
    return {
      href: url.href,
      // URL exposes internationalized domains as ASCII punycode, making the
      // actual destination visible instead of trusting a message's link label.
      hostname: url.host,
      external: !(
        url.protocol === "https:" &&
        !url.port &&
        APP_HOSTS.has(url.hostname)
      ),
      insecure: url.protocol !== "https:",
    };
  } catch {
    return null;
  }
}
